import { render } from "./_AddressCorrespondance.vue?vue&type=template&id=2d35e1ea"
import script from "./_AddressCorrespondance.vue?vue&type=script&lang=js"
export * from "./_AddressCorrespondance.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__